module.exports = __webpack_public_path__ + "media/reskin-images/icon--repeat-7224005a.svg";